
import { useEffect, useRef } from "react";
import Hero from "@/components/Hero";
import TrustBullets from "@/components/home/TrustBullets";
import HowItWorks from "@/components/HowItWorks";
import FeaturedProviders from "@/components/FeaturedProviders";
import CategoryGrid from "@/components/CategoryGrid";
import ProviderCTA from "@/components/ProviderCTA";
import AdUnit from "@/components/ads/AdUnit";
import { trackHomepageEvent } from "@/services/homepageAnalytics";

const HomeContent = () => {
  const providerSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = providerSectionRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      return;
    }

    let hasTracked = false;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTracked) {
          hasTracked = true;
          trackHomepageEvent('homepage_provider_section_view');
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Hero />
      <TrustBullets />
      <HowItWorks />
      <CategoryGrid limit={8} />
      <div className="container mx-auto py-4 overflow-hidden">
        <AdUnit adSlot="7965312393" adFormat="BANNER" className="w-full" />
      </div>
      <FeaturedProviders />
      <div className="container mx-auto py-4 overflow-hidden">
        <AdUnit adSlot="1714990002" adFormat="LEADERBOARD" className="w-full" />
      </div>
      <div ref={providerSectionRef}>
        <ProviderCTA />
      </div>
    </>
  );
};

export default HomeContent;
